import type { InputHTMLAttributes } from "react";
import clsx from "clsx";
import {
  fieldControlClassName,
  singleLineControlClassName,
} from "./form-control-styles";

export const Input = ({
  className,
  type,
  lang,
  ...props
}: InputHTMLAttributes<HTMLInputElement>) => (
  <input
    type={type}
    lang={lang ?? (type === "date" || type === "month" ? "en-CA" : undefined)}
    className={clsx(
      fieldControlClassName,
      singleLineControlClassName,
      className,
    )}
    {...props}
  />
);

export default Input;
